<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
        <v-card>
          <v-toolbar class="primary white--text">
            <v-toolbar-title class="text-xs-center">
                ASSET ACCOUNTS
            </v-toolbar-title>
            
            <v-spacer></v-spacer>  
          
            <v-card-actions class="justify-center">
                <v-btn 
                    @click="getFirms"
                    class="primary white--text">
                    ADD NEW ASSET ACCOUNT
                </v-btn>
            </v-card-actions>
          </v-toolbar>  
        <v-card>
            <template v-for="(item, index) in getAssetAccount">
              <v-divider :key="item['.key']"></v-divider>
              <v-card :key="index">
                <v-card-title>
                  <v-card-text> 
                  Firm :- <b>{{firmbyId(item.firm)}}</b> &nbsp; &nbsp; &nbsp; 
                  <!-- Bank Name :- <b>{{item.bankName}}</b> &nbsp; &nbsp; &nbsp;  -->
                  Asset Category :- <b>{{item.assetCategory}}</b> &nbsp; &nbsp; &nbsp; 
                  Asset Name :- <b>{{item.assetName}}</b> &nbsp; &nbsp; &nbsp; 
                  Asset Type :- <b>{{item.assetType}}</b> &nbsp; &nbsp; &nbsp; 
                  Account Number :- <b>{{item.accountnumber}}</b> &nbsp; &nbsp; &nbsp; 
                  </v-card-text>
                  <!-- <v-card-text> Account Holder Name :- <b>{{item.accountHolderName}}</b></v-card-text> -->
                  <v-card-text> 
                    <!-- Account Number :- <b>{{item.accountnumber}}</b> &nbsp; &nbsp; &nbsp; 
                    IFSC Code :- <b>{{item.ifsccode}}</b> &nbsp; &nbsp; &nbsp; 
                    Location :- <b>{{item.accountLocation}}</b> &nbsp; &nbsp; &nbsp;  -->
                    Available Balance :- <b>&#8377;{{item.amount}}</b> &nbsp; &nbsp; &nbsp;
                    Opening Balance :- <b>&#8377;{{item.openingBalance}}</b></v-card-text>
                  <!-- <v-card-text> Available Balance :- <b>{{item.amount}}</b> &nbsp; &nbsp; &nbsp; Firm :- <b>{{firmbyId(item.firm)}}</b></v-card-text> -->
                  <!-- <v-card-text> Firm :- <b>{{firmbyId(item.firm)}}</b></v-card-text> -->
                </v-card-title>
                <v-card-actions>
                  <v-btn flat icon class="primary white--text" @click="editAssetAccount(item['.key'])">
                    <v-icon color="grey white--text">edit</v-icon>
                  </v-btn>  
                  <v-btn flat icon class="primary white--text" @click="deleteAssetAccount(item['.key'])">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-card>
        </v-card>
    </v-flex>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title primary title class="primary white--text">
           <span class="headline">Add New Asset Account</span> 
        </v-card-title>
        <v-card-text>
          <v-select
          item-text="name"
          item-value="id"
          :items="items"
          v-model="currentFirm"
          label="Select Firms"
        ></v-select>
          <!-- <v-select
          item-text="name"
          item-value="id"
          :items="currentBankName"
          v-model="bankName"
          label="Choose Bank"
        ></v-select> -->
        <v-select
          item-text="name"
          item-value="id"
          :items="currentAssetCategory"
          v-model="assetCategory"
          label="Choose asset category"
        ></v-select>
        <v-select
          item-text="name"
          item-value="id"
          :items="currentAssetType"
          v-model="assetType"
          label="Choose Asset Type"
        ></v-select>
          <v-text-field label="Asset Name" v-model="assetName" ></v-text-field>
          <v-text-field label="Account Number" v-model="accountnumber" ></v-text-field>
          <!-- <v-text-field label="IFSC code" v-model="ifsccode" ></v-text-field>
          <v-text-field label="Location" v-model="accountLocation" ></v-text-field> -->
          <v-text-field label="Amount" v-model="initialamount" ></v-text-field>
          <v-text-field label="Opening Balance" v-model="openingBalance" ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="cancelDialog">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="addNewAssetAccount">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import { debug, debuglog } from 'util';

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
export default {
  name: 'Asset',
  data () {
    return {
      dialog: false,
      items:null,
      bankName:null,
      assetType:null,
      assetCategory:null,
      currentFirm:{
          id:'',
          name:''
      },
      currentAssetCategory: [
        'Deposit & Securities',
        'Fixed Assets',
        'Stocks/SIPS',        
      ],
      currentBankName:[
        'Allahabad Bank',
        'Andhra Bank',
        'Axis Bank',
        'Bandhan Bank',
        'Bank of India',
        'Bank Of Baroda',
        'Bank Of Maharastra',
        'Canara Bank',
        'Central Bank Of India',
        'Corporation Bank',
        'Dena Bank',
        'DCB bank',
        'HDFC bank',
        'ICICI Bank',
        'Indian Overseas Bank',
        'Kotak Mahindra Bank',
        'Oriental Bank Of Commerce',
        'Punjab National Bank',
        'Punjab and Sind Bank',
        'State Bank Of India',
        'UCO Bank',
        'Union Bank Of India',
        'Vijaya Bank',
        'Yes Bank',
      ],
      currentAssetType:[
        'Normal',
        'Depriciating',
      ],
      assetName: null,
      firms: [],
      initialamount:0,
      openingBalance:0,
      ifsccode:null,
      accountLocation:null,
      accountnumber:0,
    }
  },
  created () {
    this.$bindAsArray(
      'firms',
      this.$root.$firebaseRefs.firm
    )
    this.$bindAsArray(
      'asset',
      this.$root.$firebaseRefs.asset
    )
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand']),
    getAssetAccount () {
      if (this.selectedBrand) {
        return this.asset.filter(item => item['brand'] === this.selectedBrand)
      }
    },
    assetCount () {
      return this.getAssetAccount.length || 0
    }  
  },
  methods: {
    firmbyId(id){
      return this.firms.filter(item => item['.key'] == id)[0].name
    },
    addNewAssetAccount () {
        let data ={
          brand:this.selectedBrand,
          firm:this.currentFirm,
          // bankName:this.bankName,
          assetCategory:this.assetCategory,
          assetName:this.assetName,
          accountnumber:Number(this.accountnumber),
          // ifsccode:this.ifsccode,
          // accountLocation:this.accountLocation,
          assetType:this.assetType,
          amount:Number(this.initialamount),
          openingBalance:Number(this.openingBalance),
        }
        this.$root.$firebaseRefs.asset.push(data);
        this.addInvoice();
        this.dialog=false;
        this.currentFirm="";
        this.assetCategory="";
        this.assetName=null;
        this.assetType="";
        this.amount=0;
        this.openingBalance=0;
        // this.bankName="";
        // this.ifsccode=null;
        // this.accountLocation=null;
        this.accountnumber=0;
    },
    addInvoice(){
      let invoiceData = {
          brand: this.selectedBrand,
          type:'automatic invoice',
          firm:this.currentFirm,
          paymentType:'bank',
          accountNumber:Number(this.accountnumber),
          isCredited:true,
          totalAmount:Number(this.initialamount),
          openingBalance: Number(this.openingBalance),
          date:Date.now()
      }
      this.$root.$firebaseRefs.invoice.push(invoiceData);
    },
    deleteAssetAccount(key){
      confirm('Are you sure you want to delete this Bank Account') &&
      this.$root.$firebaseRefs.asset.child(key).remove();
    },
    cancelDialog(){
      this.dialog = false;
    },
    getFirms () {
        this.dialog =true;
        let firms = this.firms.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        firms.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
    },
    getAssetAccount () {
      this.dialog =true;
        let asset = this.asset.filter(item => item['brand'] === this.selectedBrand)
        var totalitem = [];
        asset.forEach(function (arrayItem) {
            totalitem.push({
                id :arrayItem['.key'],
                name: arrayItem.name
            })
        })
        this.items = totalitem;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings/Asset/index.vue